module.exports = __webpack_public_path__ + "static/media/play-stop.f6d2fc16.svg";